// src/components/timetable/modern/ModernTeacherPickerModal.tsx
//
// Ported from the mobile app's TeacherPickerModal.tsx. RN's bottom-sheet
// Modal becomes a PrimeReact Dialog (same primitive TimeSlotsManager.tsx /
// AddTimetableEntryModal.tsx already use for modals).

import React from 'react';
import { Dialog } from 'primereact/dialog';
import { C, initials } from './modernTimetableTypes';

interface ModernTeacherPickerModalProps {
  visible:         boolean;
  teachers:        string[];
  selected:        string | null;
  onSelect:        (t: string) => void;
  onClose:         () => void;
  presentTeachers: Set<string>;
}

const ModernTeacherPickerModal: React.FC<ModernTeacherPickerModalProps> = ({
  visible, teachers, selected, onSelect, onClose, presentTeachers,
}) => (
  <>
    <style>{`
      .mtt-picker-row {
        display: flex; align-items: center; gap: 12px; padding: 10px 8px;
        border-radius: 12px; margin-bottom: 4px; cursor: pointer; border: none; width: 100%; text-align: left;
        background: transparent; transition: background 0.15s ease;
      }
      .mtt-picker-row:hover { background: #F9FAFB; }
      .mtt-picker-row.sel { background: ${C.primaryBg}; }
      .mtt-picker-row.present { background: rgba(251,191,36,0.08); }
      .mtt-picker-row-avatar {
        width: 36px; height: 36px; border-radius: 18px; background: ${C.primaryBg};
        display: flex; align-items: center; justify-content: center; flex-shrink: 0;
        font-size: 12.5px; font-weight: 700; color: ${C.primary};
      }
      .mtt-picker-row-avatar.sel { background: ${C.primary}; color: #fff; }
      .mtt-picker-row-avatar.present { background: rgba(251,191,36,0.25); border: 1.5px solid #F59E0B; color: #92400E; }
      .mtt-picker-row-name { flex: 1; font-size: 13.5px; font-weight: 500; color: ${C.textPrimary}; }
      .mtt-picker-row-name.sel { font-weight: 700; color: ${C.primary}; }
      .mtt-picker-row-name.present { color: ${C.present}; }
      .mtt-picker-badge {
        background: rgba(245,158,11,0.15); border: 1px solid rgba(245,158,11,0.4); border-radius: 6px;
        padding: 2px 7px; font-size: 10px; font-weight: 700; color: ${C.present};
      }
    `}</style>
    <Dialog
      header="Select Teacher"
      visible={visible}
      onHide={onClose}
      style={{ width: '90vw', maxWidth: '420px', borderRadius: '20px' }}
      contentStyle={{ padding: '12px 20px 20px', maxHeight: '65vh', overflowY: 'auto' }}
      modal
      dismissableMask
      draggable={false}
      resizable={false}
    >
      {teachers.map((t) => {
        const isPresent  = presentTeachers.has(t);
        const isSelected = selected === t;
        return (
          <button
            key={t}
            type="button"
            className={`mtt-picker-row ${isSelected ? 'sel' : ''} ${isPresent ? 'present' : ''}`}
            onClick={() => { onSelect(t); onClose(); }}
          >
            <div className={`mtt-picker-row-avatar ${isSelected ? 'sel' : ''} ${isPresent && !isSelected ? 'present' : ''}`}>
              {initials(t)}
            </div>
            <div className={`mtt-picker-row-name ${isSelected ? 'sel' : ''} ${isPresent ? 'present' : ''}`}>{t}</div>
            {isPresent && <span className="mtt-picker-badge">Present</span>}
            {isSelected && <i className="pi pi-check-circle" style={{ color: C.primary, fontSize: 16 }} />}
          </button>
        );
      })}
    </Dialog>
  </>
);

export default ModernTeacherPickerModal;
